import { MotivationPIndicatorEnum, MotivationType } from "tm-shared/types";
import { formatNumber, formatUAHNumber, roundTo } from "tm-shared/utils";

import { KPI_ICONS } from "./constants";

export const motivationTypeByIndicator: Partial<
    Record<MotivationPIndicatorEnum, MotivationType>
> = {
    [MotivationPIndicatorEnum.Bottle]: "b",
    [MotivationPIndicatorEnum.Money]: "m",
    [MotivationPIndicatorEnum.Capacity]: "l",
};

export const formatKPIValue = ({
    value = 0,
    motivationType,
}: {
    value?: number;
    motivationType?: MotivationType;
}): string => {
    switch (motivationType) {
        case "b":
            return formatNumber(value, 0);
        case "m":
            return formatUAHNumber(value);
        case "l": {
            const roundedValue = roundTo(value, 3);
            const decimalPlaces = (roundedValue.toString().split(".")[1] || "")
                .length;

            return formatNumber(roundedValue, decimalPlaces);
        }
        default:
            return "";
    }
};

export const formatValueIndicator = ({
    value = 0,
    indicator,
}: {
    value?: number;
    indicator?: MotivationPIndicatorEnum;
}): string =>
    formatKPIValue({
        value,
        motivationType: indicator
            ? motivationTypeByIndicator[indicator]
            : undefined,
    });

export const getMotivationImage = (indicator?: MotivationPIndicatorEnum) => {
    const motivationType = indicator
        ? motivationTypeByIndicator[indicator]
        : undefined;
    const Icon = motivationType ? KPI_ICONS[motivationType] : undefined;

    return Icon ? <Icon /> : "unexpected indicator type";
};
